import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DataquealityCheckformComponent } from './dataqueality-checkform.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';

import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';

// your custom modules
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomRadioButtonModule } from 'src/app/shared/components/custom-radio-button/custom-radio-button.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { ExpansionPanelModule } from 'src/app/shared/components/expansion-panel/expansion-panel.module';
import { ForceApprovePopupModule } from 'src/app/shared/components/force-approve-popup/force-approve-popup.module';
import { MaterialModule } from 'src/app/shared/material/material.module';

// routing
import { DataquealityCheckformRoutingModule } from './dataqueality-checkform-routing.module';


@NgModule({
  declarations: [
    DataquealityCheckformComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    CustomInputModule,
    CustomDropdownModule,
    CustomDatePickerModule,
    CustomRadioButtonModule,
    ReactiveFormsModule,
  


    // routing
    DataquealityCheckformRoutingModule
  ]
})
export class DataquealityCheckformModule { }